import EmptyBox from "icons/EmptyBox"
import type { FC, ReactNode } from "react"

interface EmptyStateProps {
  children: ReactNode
  padding?: "sm" | "md" | "lg"
}

const EmptyState: FC<EmptyStateProps> = ({ children, padding = "md" }) => {
  const paddingClasses = {
    sm: "p-2",
    md: "p-24",
    lg: "p-32",
  }

  return (
    <div
      className={`w-full h-full grid place-items-center ${paddingClasses[padding]}`}
    >
      <div className="text-center place-items-center grid py-12">
        <EmptyBox className="w-24" />
        <h1 className="mt-10 text-gray-700 font-semibold text-2xl">
          {children}
        </h1>
      </div>
    </div>
  )
}

export default EmptyState
